<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gLYAxl/tc-custom/9780300249033.jpg?1697248410267" alt="This image is the cover for the book Marie-Antoinette"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marie-Antoinette
      </h1>
      <p class="bookDescription body article font2">
        <b>This “wonderfully gripping biography” digs beneath the famous legend to present a nuanced and revealing portrait of a serious-mined monarch (Allan Massie, <i>Wall Street Journal</i>).</b><br/><br/>As the last Queen of France before the French Revolution, Marie-Antoinette was mistrusted and reviled in her own time, while today she is portrayed as a lightweight incapable of understanding the events that engulfed her. But who was she really? In this new account, John Hardman redresses the balance and sheds fresh light on her story.<br/><br/>Hardman shows how Marie-Antoinette played a significant but misunderstood role in the crisis of the monarchy. Drawing on new sources, he describes how she refused to prioritize the aggressive foreign policy of her mother, bravely took over the helm from her faltering husband, and, when revolution broke out, worked closely with repentant radicals to give the constitutional monarchy a fighting chance. For the first time, Hardman demonstrates exactly what influence Marie-Antoinette had and when and how she exerted it.<br/><br/><b>Named a 2020 Book of the Year by <i>The Spectator</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Hardman
      </h2>
      
      <p class="authorDescription body article">John Hardman is one of the world's leading experts on the French Revolution and the author of several well-regarded books on the subject. He was formerly a lecturer in modern history at the University of Edinburgh.Jonathan Cowley is a British voice actor who calls Los Angeles home. He has received AudioFile Earphones Awards for his narration of The Science of Evil by Simon Baron-Cohen, The Tower, the Zoo and the Tortoise by Julia Stuart, and The Angry Chef's Guide to Spotting Bullsh*t in the World of Food by Anthony Warner.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e98d5a72